'use client'; // svs/ui requires "use client"

import { Switch } from '@svenskaspelab/ui/react/switch';
import type { ComponentProps, ReactNode } from 'react';

import { cn } from '../../utils/entry.js';

type CheckBoxItemProps = ComponentProps<typeof Switch>;

/**
 * Component that is to be used with CheckboxGroup component for rendering checkbox in the forms.
 *
 * @param root0 the input props
 * @param root0.children the children to pass down
 * @param root0.className the className to apply to the Switch component
 * @param root0.id the id for the checkbox
 * @param root0.rest the rest of the input props which would be common input props for the Checkbox input field.
 * @returns component
 */
export default function CheckboxItem({ children, className, id, ...restProps }: CheckBoxItemProps): ReactNode {
  return (
    <div className="border-stroke-low flex items-center justify-between border-b pb-1">
      <label
        htmlFor={id}
        className="font-regular text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      >
        {children}
      </label>
      <Switch
        {...restProps}
        nativeButton
        render={<button type="button" value={restProps.value} />}
        id={id}
        className={cn(
          'data-[checked]:bg-secondary data-[unchecked]:bg-stroke-high data-[checked]:[&>*]:translate-x-6.5 data-[unchecked]:[&>*]:translate-x-0.5',
          className
        )}
      />
    </div>
  );
}
